<template>
  <nav>
    <v-app-bar color="white" dark app>
      <v-app-bar-nav-icon
        class="black--text"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase"> </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <v-list flat>
          <v-list-item
            v-for="link in filteredLinks"
            :key="link.text"
            router
            :to="link.route"
          >
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" dark app class="sidebar darken-4">
      <v-layout column align-center>
        <v-flex class="mt-5">
          <img
            class="sidebar_logo"
            @click="$router.push('/')"
            style="cursor: pointer;"
            src="../assets/rpsg.png"
            alt=""
          />
        </v-flex>
        <v-flex class="mt-4 mb-4">
          <Popup />
        </v-flex>
      </v-layout>
      <v-list flat>
        <template v-for="link in links">
          <!-- Parent item -->
          <v-list-group v-if="link.children" :key="link.text" no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon>{{ link.icon }}</v-icon> {{ link.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- Child items -->
            <v-list-item
              v-for="sublink in link.children"
              :key="sublink.text"
              router
              :to="sublink.route"
              class="border1"
              :class="{ highlighted: isActive(sublink) }"
            >
              <v-list-item-action>
                <v-icon>{{ sublink.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ sublink.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  data: () => ({
    drawer: true,
    authKey: localStorage.getItem("auth-key"),
    links: [
      {
        icon: "folder_open",
        text: "DISHA",
        children: [
          {
            icon: "business",
            text: "HO - Operations",
            route: "/home/disha/operations",
          },
          {
            icon: "home",
            text: "Store - Operation",
            route: "/home/disha/StoreOperation",
          },
          {
            icon: "attach_money",
            text: "Finance",
            route: "/home/disha/finance",
          },
          { icon: "mdi-apple-keyboard-command", text: "Marketing", route: "/home/disha/marketing" },
          { icon: "mdi-cube-send", text: "Alliance", route: "/home/disha/alliance" },
          { icon: "mdi-dip-switch", text: "SRD", route: "/home/disha/srd" },
          { icon: "mdi-floppy", text: "SOP", route: "/home/disha/sop" },
          { icon: "group", text: "Legal", route: "/home/disha/legal" },
          
          {
            icon: "mdi-widgets",
            text: "Merchandiser",
            route: "/home/disha/merchandiser",
          },
        ],
      },
      {
        icon: "dashboard",
        text: "Phone Delivery",
        children: [
          {
            icon: "business_center",
            text: "HO-Operations",
            route: "/home/ivr/ho_operations",
          },
          { icon: "home", text: "Store Operation", route: "/home/ivr/store_operations" },
          // { icon: "home", text: "Regional Operation", route: "/home/ivr/regional" },
          { icon: "mdi-chart-pie", text: "MIS", route: "/home/ivr/mis" },
          { icon: "list", text: "B2B", route: "/home/ivr/b2b" },
        ],
      },
    ],
  }),
  computed: {
    filteredLinks() {
      return this.links.filter((link) => !link.children);
    },
    tempAuthKey() {
      return localStorage.getItem("authKey");
    },
  },
  methods: {
    isActive(link) {
      if (this.$route.path.includes(link.route)) {
        return true;
      }
      if (link.children) {
        return link.children.some((child) =>
          this.$route.path.includes(child.route)
        );
      }
      return false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.highlighted {
  background-color: #f28a3e !important;
  color: white !important;
}
</style>

